var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"root"},[_c('router-view'),_c('portal-target',{attrs:{"name":"modal"}}),_c('div',{attrs:{"id":"bank-payment-widget"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }